<template>
  <div id="app">
    <router-view />
    <div class="cookie text-center" v-if="showGdprText">
      <a @click="gdprOnAccept()" href="javascript:void(0)">
        <img
          src="@/assets/images/close-button.svg"
          class="close-button-cookie"
        />
      </a>
      <div class="row justify-content-center">
        <div class="col-xl-8 col-12">
          <p v-html="$t('cookiesBoxText')">{{ $t("cookiesBoxText") }}</p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-xl-2 col-6">
          <a
            href="javascript:void(0)"
            @click="gdprOnAccept()"
            class="buton customButon textAlb backgroundRosu bold"
            >{{ $t("cookiesAcceptBotton") }}</a
          >
        </div>
        <div class="col-xl-2 col-6">
          <a
            href="javascript:void(0)"
            @click="showModalPopup('modal_popup_cookie', true)"
            class="buton customButon textAlb backgroundRosu"
            >{{ $t("cookiesCookiePreferences") }}</a
          >
        </div>
      </div>
    </div>
    <div id="modal_popup_cookie" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_cookie', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div class="scroll-window">
          <Cookie />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from "@/http/http-common.js";

import Cookies from "js-cookie";
import Cookie from "@/views/Cookies.vue";

export default {
  name: "app",
  components: {
    Cookie,
  },
  data() {
    return {
      href: null,
      showGdprText: false,
    };
  },
  methods: {
    gdprOnAccept() {
      Cookies.set("GDPR", "true");
      Cookies.set("functional", "true");
      Cookies.set("analytics", "true");
      Cookies.set("marketing", "true");
      // this.$gtm.enable(true);
      // this.$ga.enable(true);
      this.showGdprText = false;
    },
    // showModalPopup(elementId, show) {
    //   if (show) {
    //     this.gdprOnAccept();
    //     document.getElementById(elementId).style.visibility = "visible";
    //   } else {
    //     document.getElementById(elementId).style.visibility = "hidden";
    //   }
    // },
  },
  destroyed() {
    Cookies.remove("user_role");
    Cookies.remove("token");
    localStorage.clear();
    Cookies.clear();
  },
  mounted() {
    if (!localStorage.language) {
      localStorage.language = "ro";
    }
    this.showGdprText = Cookies.get("GDPR") == null; //show if cookie not set

    httpService.commonsService.getConfigFile(localStorage.language, "club");
  },
};
</script>
<style scoped src="@/assets/styles/login.css"></style>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

html {
  overflow: hidden;
}

.language-button {
  padding: 5px;
  cursor: pointer;
  font-size: 22px;
  opacity: 0.5;
}

.language-div {
  text-align: right;
  padding-right: 10px;
  padding-top: 5px;
  height: 30px;
}

.close-button-cookie {
  position: absolute;
  right: 5px;
  top: 5px;
  width: 20px;
  cursor: pointer;
}

::-webkit-scrollbar {
	-webkit-appearance: none;
	appearance: none;
	width: 10px;
}

::-webkit-scrollbar-thumb {
	border-radius: 5px;
	background-color: rgba(0, 0, 0, 0.5);
	box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
	-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
